module.exports = __webpack_public_path__ + "static/media/image-4@3x.d1ae92bd.png";